//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
import { Tooltip } from 'antd';
import Loading from 'components/Loading';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleListGame } from 'store/one_game/thunks';
import styled from "styled-components";
import { IGameHome8 } from "utils/assets/images";
import StudyLoader from './StudyLoaader';
import {useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { captureException } from '@sentry/react';

const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? `'${p.src}'` : IGameHome8});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;

const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function AdminStudy({ gameDuplicateLoader, bookId, pageId, userId, onGameSelect, startGame, gameInitLoader, onDuplicateGame = () => { }, oneStudyType, newMaskId, backToLabelStory, resource }) {
    const location = useLocation();
    const search = queryString?.parse(location.search);
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const dispatch = useDispatch();

    const loadData = async () => {
        try{
            setLoading(true)
            const response = await dispatch(handleListGame(userId, bookId, pageId, 'owe_admin', '1study', backToLabelStory == 'Stories' ? true : false, resource));
            const data = response?.data || [];
            let filteredGames;
            if (data.length > 0) {
                if (oneStudyType === 'flash_card') {
                    filteredGames = data.filter(obj => obj.study_metadata?.type === 'flash_card');
                } else if (oneStudyType === 'quiz') {
                    filteredGames = data.filter(obj => obj.study_metadata?.type === 'quiz');
                } else {
                    if (backToLabelStory === 'Stories') {
                        const storyData = data?.filter((obj) => obj?.games_metadata?.story?.id === search?.id && obj?.games_metadata?.story?.level === search?.level)
                        filteredGames = storyData;
                    } else {
                        filteredGames = data;
                    }
                }
            } else {
                filteredGames = [];
            }
            setGames(filteredGames);
            setLoading(false);
        }catch(error){
            captureException(`Error in loadData: ${error}`, {
                tags: {
                    component: 'AdminStudy',
                    function: 'loadData'
                }
            });
        }
    }
    useEffect(() => {
        loadData();
    }, [pageId, oneStudyType])
    if (isLoading) {
        return (<StudyLoader />);
    }
    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No study available!</div>
        </div>
        )
    }

    return (
        <Slider {...settings}>
            {games.map((item, index) => {
                const image_url = item.media_urls ? item.media_urls.image : IGameHome8
                const isGameLoading = gameInitLoader && selectedGame.game_id === item.game_id;
                const studyMetaData = get(item, 'study_metadata', '') || {};
                return (
                    <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                        <div className='myUnitsBnr draftImage-game frameStyle'>
                            {/* <Cover src={image_url} /> */}
                            <img
                                src={image_url}
                                alt=""
                                className='imageStyle'
                            />
                            {item?.status === 'false' && (
                                <div className='draftText-game'>Draft</div>
                            )}
                        </div>
                        <div className='myUnitsTxt'>
                            <div className='myUnitsInfo'>
                                {item?.display_name && item.display_name.length > 20 ? (
                                    <Tooltip title={item.display_name}>
                                        <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label>
                                    </Tooltip>
                                ) : (
                                    <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                )}
                                <p>{item?.category?.category_name || "--"}</p>
                                {newMaskId ? (
                                    <span>Pg. {newMaskId || '--'}</span>
                                ) : (
                                    <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                                )}
                                <span>{`No. of Questions: ${item?.question_length}`}</span>
                            </div>
                            <div className='myUnitsBtns'>
                                <a className={`study-cursor`}>{studyMetaData?.type === 'flash_card' ? "Flashcard" : "Quiz"}</a>
                                <a
                                    onClick={() => {
                                        if (isGameLoading || gameInitLoader) {
                                            return false;
                                        }
                                        if (item?.status === 'true' && item?.question_length > 0) {
                                            setSelectedGame(item);
                                            startGame(item);
                                        }
                                    }}
                                    className={`BtnsStart ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`}>
                                    <ArrowRightRounded />{gameInitLoader && selectedGame.game_id === item.game_id ? <Loading size={12} white /> : null} start
                                </a>
                            </div>
                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="px-4">
                                <div onClick={() => {
                                    onDuplicateGame(item)
                                }}>
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>{gameDuplicateLoader === item.game_id ? <Loading size={15} /> : null} Duplicate</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Slider>
    )
}